/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Voucher_Not_ApplicableInputs */

const en_billing_voucher_not_applicable = /** @type {(inputs: Billing_Voucher_Not_ApplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This voucher doesn't apply to that plan.`)
};

const id_billing_voucher_not_applicable = /** @type {(inputs: Billing_Voucher_Not_ApplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voucher ini tidak berlaku untuk paket itu.`)
};

/**
* | output |
* | --- |
* | "This voucher doesn't apply to that plan." |
*
* @param {Billing_Voucher_Not_ApplicableInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_voucher_not_applicable = /** @type {((inputs?: Billing_Voucher_Not_ApplicableInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Voucher_Not_ApplicableInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_voucher_not_applicable(inputs)
	return en_billing_voucher_not_applicable(inputs)
});